import Field from "../../model/refbooks/field";
import View from "../view";

import { attach } from '../../model/task.utils';
import { hashify } from "../../utils/arrays";





export default View.extend( {

    [View.event( 'file:toggle' )](index) {
        const file = this.files()[index];
        const id = file.guid || file.id;

        this.model.set( 'attachments', this.model.get( 'attachments' ).map( ({ ...att, deleted }) => 
            att.id === id || att.guid === id
                ? { ...att, deleted: deleted == undefined || deleted == false || deleted == 'f' }
                : { ...att, deleted } ) );
    },

    [View.event( 'Controls:file:upload-done' )](originalName, type, semantics, uploading, binaryFile) {
        const { def, path } = this.options;

        // add to gallery
        const attrs = attach( this.model, originalName, type, semantics, uploading, binaryFile );

        const [files, label, meta] = this.bindingFilters.prepareCf.get( this.model.get( 'fields' ), this.model.id, 
            def.id, def.translit, def.format, null, def.min_count,
            undefined, undefined, undefined, 
            undefined,
            path );

        // always add to the end
        const newFiles = [...files, { guid: attrs.guid }];
        this.model.set(
            this.bindingFilters.prepareCf.set( [newFiles, label, meta] ) );

        this.render();

        // todo upload errors
    },

    files() {
        const { def, path } = this.options;
        const { translit } = def;

        const fields = (path || '')
            .split( '|' )
            .map( part => part.split( '=' ) )
            .map( ([id, encodedTranslit, index]) => 
                [Field.decodeString( encodedTranslit ), index] )
            .reduce( (fields, [translit, index]) => 
                fields && fields[translit] && fields[translit].value && fields[translit].value[index] || undefined, 
                this.model.get( 'fields' ) )
            || this.model.get( 'fields' );

        return fields && fields[translit] && fields[translit].value || [];
    },

    serialize() {
        const deleted = hashify( this.model.get( 'attachments' )
            .filter( ({ deleted }) => deleted === true || deleted === 't' )
            .map( ({ id, guid }) => id || guid ) );

        const files = this.files();
        const filesTotal = files.length;
        const deletedFilesTotal = files.filter( ({ id, guid }) => deleted[id || guid] ).length;
        return {
            filesTotal,
            deletedFilesTotal,
            nonDeletedFilesTotal: filesTotal - deletedFilesTotal,
        };
    },

    onBind(model) {
        this.listenTo( model, 'change:attachments',
            () => this.render() );
    },

    onUnBind(previousModel) {
        this.stopListening( previousModel );
    }, 

} );


// WEBPACK FOOTER //
// ./src/js/view/field/gallery.js